export const errorConstants = {
  SET_ERROR: "SET_ERROR",
  CLEAN_ERROR: "CLEAN_ERROR",
};
